import { BaseClient, normalizeQuery } from '../base-client';
import type {
  ApproveSkillSubmissionInput,
  ApproveSkillSubmissionResponse,
  ExistingSkillMatch,
  ListSkillSubmissionsQuery,
  RejectSkillSubmissionInput,
  SkillSubmission,
  SubmitSkillInput,
} from './types';

type One = { data: SkillSubmission };
type ListResponse = {
  data: SkillSubmission[];
  meta: { total: number; limit: number; offset: number };
  /** Requests whose name is already in the catalog (ignoring case), keyed
   *  by submission id. */
  related: { existingSkills: Record<string, ExistingSkillMatch> };
};

export class SkillSubmissionsClient extends BaseClient {
  list(query: ListSkillSubmissionsQuery = {}): Promise<ListResponse> {
    return this.request('/api/skill-submissions', { query: normalizeQuery(query) });
  }

  /** Any authenticated user may submit — "Request a new skill" on My Skills. */
  submit(input: SubmitSkillInput): Promise<One> {
    return this.request('/api/skill-submissions', { method: 'POST', body: input });
  }

  /** Resolve a request. A name already in the catalog (ignoring case) is
   *  closed against that skill instead of creating a duplicate — see
   *  `related.outcome`. */
  approve(
    id: string,
    input: ApproveSkillSubmissionInput = {},
  ): Promise<ApproveSkillSubmissionResponse> {
    return this.request(`/api/skill-submissions/${encodeURIComponent(id)}/approve`, {
      method: 'POST',
      body: input,
    });
  }

  reject(id: string, input: RejectSkillSubmissionInput): Promise<One> {
    return this.request(`/api/skill-submissions/${encodeURIComponent(id)}/reject`, {
      method: 'POST',
      body: input,
    });
  }
}
